import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { H4 } from '@blueprintjs/core';
import { Paper, TablePagination  } from '@material-ui/core';
import MaterialTable from 'material-table';
import { rounded } from '../../../utils.js'

class MLM extends React.PureComponent {

  state = {

  }


  render() {
      const {  t,mlmStats } = this.props;
      console.log(mlmStats);
      const columnDefinition=[
        { title: t('realization'), field: 'realization' },
        { title: t('freq'), 
          field: 'freq',
          customFilterAndSearch: (term, rowData) => ~~term <= ~~rowData.freq,           
        },
        { title: t('averageProba')+ " (%)", 
          field: 'averageProba',
          customFilterAndSearch: (term, rowData) => ~~term <= ~~rowData.averageProba,           
        },
        { title: t('guessedProba')+ " (%)", 
          field: 'guessedProba',
          customFilterAndSearch: (term, rowData) => ~~term <= ~~rowData.guessedProba,
        },
        { title: t('similarForms'), 
          field: 'similarForms'}
      ];

      const tables= Object.keys(mlmStats).map( key => { 
        const data= Object.keys(mlmStats[key]).map( form => { 
          return { 
            realization:form,
            freq:mlmStats[key][form]['freq'],
            averageProba:rounded(mlmStats[key][form]['proba']*100,2),
            guessedProba:rounded(mlmStats[key][form]['guessed']*100,2),
            similarForms:mlmStats[key][form]['similarTokens'].map( pair => pair[0]+" ("+pair[1].toString()+")").join(", "),
          }
        });
    
        return <MaterialTable
            key={'token '+key}
            title={'token '+key}
            columns={columnDefinition}
            data={data}
            options={{
              filtering: true,
              search: true,
              sorting: true,
              exportButton: true,
              exportFile: 'mlm',
              exportDelimiter:this.props.csvDelimiter,
              exportAlldata: true,
              rowStyle: {
                height:'70px',
              },
              padding: 'dense',
            }}
            components={{
              Pagination: props => (
                <TablePagination
                  {...props}
                  rowsPerPageOptions={[10, 25, 50, 100, 500 ]}
                />
              ),
              Container: props => (
                <Paper
                  {...props}
                  elevation={0}
                />
              ),
            }}
        />  
      });

      
      
      return (
        <>
          <div className="margin-top-2-rem">
            <H4>{t('query')}: {this.props.query}</H4>
            <br/>
            {tables}  
          </div>
        </>
      );
  }
}

MLM.propTypes = {
  mlmStats: PropTypes.object,
  query: PropTypes.string,
  csvDelimiter: PropTypes.string,
};

export default withTranslation()(MLM);
